import {Button, Modal} from 'react-bootstrap';
import React from 'react';
import PropertyWorkPanel from '../collaboration/PropertyWorkPanel';
export function PropertyIssueModel({show, job, handleClose, onIssueSummaryChanged}) {
    return <Modal show={show} onHide={handleClose} dialogClassName="custom-modal-width" onClick={event => event.stopPropagation()}>
        <Modal.Header closeButton><Modal.Title>Property Issues</Modal.Title></Modal.Header>
        <Modal.Body>{show && job?.property_id ? <PropertyWorkPanel propertyId={job.property_id} cosJobId={job.cos_job_id}
            onIssueSummaryChanged={onIssueSummaryChanged}/> : null}</Modal.Body>
        <Modal.Footer><Button variant="secondary" onClick={handleClose}>Close</Button></Modal.Footer>
    </Modal>;
}
